import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { CardModule, SpinnerModule } from '@spartacus/storefront'
import { AddressFormModule } from "@spartacus/user/profile/components"
import { CustomCartModule } from '../../cart/custom-cart.module'
import { MaterialModule } from '../../shared/material.module'
import { SharedModule } from '../../shared/shared.module'
import { CustomParagraphModule } from '../custom-shipping-address/custom-paragraph/custom-paragraph.module'
import { CustomDeliveryAddressComponent } from './custom-delivery-address.component'

@NgModule({
  declarations: [CustomDeliveryAddressComponent],
  imports: [
    CommonModule,
    RouterModule,
    AddressFormModule,
    CardModule,
    SpinnerModule,
    I18nModule,
    MaterialModule,
    CustomParagraphModule,
    SharedModule,
    CustomCartModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CheckoutDeliveryAddress: {
          component: CustomDeliveryAddressComponent
        }
      }
    })
  ]
})
export class CustomDeliveryAddressModule { }
